import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { agentNodeName, byAgentNodeKind } from '@/utils/agent-node';
import type { Suggestion } from '../../store/types';
import PatchCard from './primitives/patch-card';
import SuggestionProse from './primitives/suggestion-prose';
type GhostNodeProps = {
  suggestion: Suggestion;
};
const GhostNode = t0 => {
  const $ = _c(27);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  if (suggestion.operation.kind !== "add_node") {
    return null;
  }
  const node = suggestion.operation.node;
  let t2;
  if ($[1] !== node || $[2] !== t) {
    t2 = node.kind === "decision" ? t(_temp) : byAgentNodeKind(node, t(_temp2), t(_temp3), t(_temp4));
    $[1] = node;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const note = t2;
  const rulesKey = node.kind === "rules" ? node.key : undefined;
  const t3 = suggestion.id;
  const t4 = !suggestion.canApply;
  let t5;
  if ($[4] !== node) {
    t5 = agentNodeName(node);
    $[4] = node;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== node.kind || $[7] !== node.prompt) {
    t6 = node.kind === "task" && node.prompt && <SuggestionProse>{node.prompt}</SuggestionProse>;
    $[6] = node.kind;
    $[7] = node.prompt;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== node.defaultValue || $[10] !== node.groups || $[11] !== node.kind || $[12] !== t) {
    t7 = node.kind === "rules" && <div className="text-body-3 text-tertiary">{node.groups.length === 1 ? t(_temp5, {
        value: node.defaultValue
      }) : t(_temp6, {
        count: node.groups.length,
        value: node.defaultValue
      })}</div>;
    $[9] = node.defaultValue;
    $[10] = node.groups;
    $[11] = node.kind;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== node.kind || $[15] !== node.questions || $[16] !== t) {
    t8 = node.kind === "decision" && <div className="text-body-3 text-tertiary">{node.questions.length === 1 ? t(_temp7, {
        keys: node.questions[0]?.key ?? ""
      }) : t(_temp8, {
        count: node.questions.length,
        keys: node.questions.map(_temp9).join(", ")
      })}</div>;
    $[14] = node.kind;
    $[15] = node.questions;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== note || $[19] !== rulesKey || $[20] !== suggestion.id || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <div className="mb-3"><PatchCard suggestionId={t3} note={note} isStale={t4} title={t5} subtype={rulesKey}>{t6}{t7}{t8}</PatchCard></div>;
    $[18] = note;
    $[19] = rulesKey;
    $[20] = suggestion.id;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default GhostNode;
function _temp($) {
  return $.decision.add;
}
function _temp2($_0) {
  return $_0.task.add;
}
function _temp3($_1) {
  return $_1.rules.add;
}
function _temp4($_2) {
  return $_2.node.add;
}
function _temp5($_3) {
  return $_3.rules.groupsSummaryOne;
}
function _temp6($_4) {
  return $_4.rules.groupsSummaryMany;
}
function _temp7($_5) {
  return $_5.decision.questionsSummaryOne;
}
function _temp8($_6) {
  return $_6.decision.questionsSummaryMany;
}
function _temp9(question) {
  return question.key;
}